import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationPolicyIntentProjectAttachArgs, PolicyStackAttachment } from "types/generated";

export const ATTACH_POLICY_TO_INTENT_PROJECT: TypedDocumentNode<
  { policyIntentProjectAttach: PolicyStackAttachment },
  MutationPolicyIntentProjectAttachArgs
> = gql`
  mutation AttachPolicyToIntentProject($id: ID!, $intentProject: ID!) {
    policyIntentProjectAttach(id: $id, intentProject: $intentProject) {
      id
    }
  }
`;
